export default function ({ action, link }) {
    return (
        <>
            <h3 className="text-lg leading-6 font-medium text-black">
                Oglas je uspješno objavljen!
            </h3>
            <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-dark">
                    Oglas je odmah vidljiv preko direkt linka, a biće objavljen
                    na listingu čim ekipa pregleda.
                </p>
            </div>
            <div className="items-center px-4 py-3">
                <button
                    onClick={() => action(true)}
                    className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full mb-3 shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
                >
                    Dodaj Novi Oglas, očisti polja.
                </button>
                <button
                    onClick={() => action(false)}
                    className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full mb-3 shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
                >
                    Dodaj Novi Oglas, zadrži uneseno.
                </button>
                <a
                    href={link}
                    target="_blank"
                    className="px-4 py-2 border-gray border text-base font-medium rounded-md w-full mb-3 shadow-sm focus:outline-none focus:ring-2 hover:bg-gray-light"
                >
                    Pogledaj Oglas
                </a>
            </div>
        </>
    );
}
